import React from "react";
import { View, ActivityIndicator, StyleSheet } from "react-native";
import { COLORS } from "../../constants";
/**
 * Loading.jsx
 *
 * This component displays a loading indicator when data is being fetched.
 * It provides a centered activity spinner to indicate progress.
 */
const Loading = () => {
  return (
    <View style={styles.centerContainer}>
      <ActivityIndicator animating={true} color={COLORS.primary} size="large" />
    </View>
  );
};

const styles = StyleSheet.create({
  centerContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default Loading;
